import {
  BusinessAccountInvoiceInstructionsDto,
  BusinessAccountInvoiceInstructionsModel,
} from '../types/transactions'
import { transformAddressDto } from './business-address'

export const transformBusinessAccountInvoiceInstructionsDto = (
  business_account_invoice_instructions: BusinessAccountInvoiceInstructionsDto,
): BusinessAccountInvoiceInstructionsModel => {
  const {
    buyer: { address, email },
  } = business_account_invoice_instructions

  return {
    address: transformAddressDto(address),
    email,
  }
}
